import { adminApi } from '~/api'
import { useQuery } from '@tanstack/react-query'

export const useUpcomingCoursesQuery = () =>
  useQuery({
    queryKey: ['upcoming-courses'],
    queryFn: async () => {
      const { data } = await adminApi.getUpcomingCourses()
      return data.data
    }
  })

export const usePastCoursesQuery = () =>
  useQuery({
    queryKey: ['past-courses'],
    queryFn: async () => {
      const { data } = await adminApi.getPastCourses()
      return data.data
    }
  })

export const useGetDoctors = () =>
  useQuery({
    queryKey: ['doctors'],
    queryFn: async () => {
      const { data } = await adminApi.getDoctors()
      return data.data
    }
  })
